import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Shop = () => {
  const navigate = useNavigate();

  return (
    <div className="shop-container">
      {/* Navigation */}
      <nav className="arven-nav scrolled">
        <div className="nav-content">
          <div className="nav-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>ARVEN ARCHITECTS</div>
          <div className="nav-links">
            <button onClick={() => navigate('/')} className="nav-link">Home</button>
            <button onClick={() => navigate('/#products')} className="nav-link">Collection</button>
            <button onClick={() => navigate('/#about')} className="nav-link">About</button>
            <button onClick={() => navigate('/#craft')} className="nav-link">Philosophy</button>
            <button onClick={() => navigate('/#contact')} className="nav-link">Contact</button>
          </div>
        </div>
      </nav>

      {/* Shop Content */}
      <section className="shop-section">
        <div className="shop-content">
          <button onClick={() => navigate('/')} className="back-button">
            <ArrowLeft size={20} />
            <span>Back to home</span>
          </button>

          <div className="shop-header">
            <h1 className="shop-title">Shop</h1>
            <p className="shop-subtitle">Handcrafted height-adjustable desks</p>
          </div>

          <div className="shop-grid">
            <div className="shop-images">
              <div className="shop-image-wrapper">
                <img
                  src="https://customer-assets.emergentagent.com/job_scandi-home-craft/artifacts/4ic7wj25_DSC06750.jpg"
                  alt="Arven desk detail"
                  className="shop-image"
                />
              </div>
            </div>

            <div className="shop-pricing">
              <div className="pricing-card">
                <h2 className="pricing-title">Price per table</h2>
                
                <div className="pricing-list">
                  <div className="pricing-item">
                    <span className="pricing-quantity">1</span>
                    <span className="pricing-dots"></span>
                    <span className="pricing-amount">15.000 DKK</span>
                  </div>
                  
                  <div className="pricing-item">
                    <span className="pricing-quantity">3</span>
                    <span className="pricing-dots"></span>
                    <span className="pricing-amount">12.500 DKK</span>
                  </div>
                  
                  <div className="pricing-item">
                    <span className="pricing-quantity">5 or more</span>
                    <span className="pricing-dots"></span>
                    <span className="pricing-amount">10.000 DKK</span>
                  </div>
                </div>

                <p className="pricing-note">All prices ex. moms</p>

                <div className="color-options">
                  <h3 className="color-options-title">Available finishes</h3>
                  <div className="color-swatches">
                    <div className="color-swatch" style={{backgroundColor: '#E8DCC8'}} title="Splash 201"></div>
                    <div className="color-swatch" style={{backgroundColor: '#CDC9B8'}} title="Splash 202"></div>
                    <div className="color-swatch" style={{backgroundColor: '#9B9482'}} title="Splash 203"></div>
                    <div className="color-swatch" style={{backgroundColor: '#3D3D3D'}} title="Splash 204"></div>
                    <div className="color-swatch" style={{backgroundColor: '#D4B989'}} title="Splash 205"></div>
                    <div className="color-swatch" style={{backgroundColor: '#A67C52'}} title="Splash 206"></div>
                    <div className="color-swatch" style={{backgroundColor: '#8B5A3C'}} title="Splash 207"></div>
                    <div className="color-swatch" style={{backgroundColor: '#654432'}} title="Splash 208"></div>
                    <div className="color-swatch" style={{backgroundColor: '#C17A4A'}} title="Splash 209"></div>
                    <div className="color-swatch" style={{backgroundColor: '#5D4A3C'}} title="Splash 210"></div>
                    <div className="color-swatch" style={{backgroundColor: '#5C3A32'}} title="Splash 211"></div>
                    <div className="color-swatch" style={{backgroundColor: '#4A3532'}} title="Splash 212"></div>
                  </div>
                  <p className="color-note">More colors available - same price</p>
                </div>

                <div className="pricing-info">
                  <p>Each desk is made to order with a lead time of 6-8 weeks.</p>
                  <p>Contact us for custom specifications and delivery options.</p>
                </div>

                <a href="mailto:contact@arven.dk" className="shop-contact-btn">
                  Request quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">ARVEN ARCHITECTS</div>
          <p className="footer-tagline">
            Handcrafted height-adjustable desks in Scandinavian design
          </p>
          
          <div className="footer-columns">
            <div className="footer-column">
              <h3 className="footer-column-title">Contact</h3>
              <div className="footer-contact">
                <p className="footer-info">contact@arven.dk</p>
                <p className="footer-info">+45 12 34 56 78</p>
                <p className="footer-info">Copenhagen, Denmark</p>
              </div>
            </div>
            
            <div className="footer-column">
              <h3 className="footer-column-title">Showroom</h3>
              <p className="footer-info">By appointment</p>
              <p className="footer-info">Mon-Fri: 10:00 - 17:00</p>
              <p className="footer-info">Sat: 11:00 - 15:00</p>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">Services</h3>
              <p className="footer-info">Bespoke consultation</p>
              <p className="footer-info">Custom solutions</p>
              <p className="footer-info">Delivery & installation</p>
            </div>
          </div>
          
          <p className="footer-copyright">© 2025 Arven Architects. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Shop;